module.exports = __webpack_public_path__ + "img/1_1.5e07af20.png";